import { FieldDefinitionTypes, SearchField } from "@/shared/search/search.types";
import { useSearchConfigQuery } from "@/shared/services/graphql/generated/consumer-graph-types";
import { computed } from "vue";

export enum DataSearchConfigId {
    product = "product",
    asset = "asset",
    article = "article",
    articleSelection = "article-selection",
    parts = "parts",
    activitiesSelection = "activities-selection",
    documentSelection = "document-selection",
}

export const useSearchConfig = (searchConfigId: DataSearchConfigId) => {
    const {
        result: searchConfigResult,
        loading,
        error,
    } = useSearchConfigQuery({
        searchConfigId: searchConfigId,
    });

    const result = computed(() => {
        if (!searchConfigResult.value) return undefined;

        const searchEntries = searchConfigResult.value.searchConfig?.entries?.map((x) => {
            const val: SearchField = {
                ...x,
                // Cast fieldType to the local FieldDefinitionTypes type
                fieldType: x.fieldType as FieldDefinitionTypes,
            };
            return val;
        });

        return {
            searchEntries,
        };
    });

    return {
        result,
        loading,
        error,
    };
};
